import { Component } from 'react';
import FilterBar from 'noc/tickets/components/filter-bar';
import FilterList from 'noc/tickets/components/filter-list';
import FilterInputPopup from 'noc/components/filter-input-popup';
import SaveViewPopUp from 'noc/components/save-new-view-popup';

class ServerFilterBar extends Component {
    render() {
        const {
            filterMenu,
            tabsData,
            requestForId,
            onCheckedOfColumnFilter,
            onTextFilter,
            getFilteredData,
            saveNewView,
            manageView,
            toggle,
            columnFilters,
            saveNewTab,
            removeTab,
            errors,
            clearErrors,
            editTab,
            clearFilters,
            filteredDataColumns
        } = this.props;

        const tabData = tabsData.find(x => x.Id === requestForId);

        return (
            <FilterBar
                isOpen={filterMenu.isStatus}
                style={{
                    right: '158px'
                }}
            >
                <FilterList>
                    {tabData
                        .QueueViewGrid
                        .GridFilters
                        .map((f, index) => (<FilterInputPopup
                            key={index}
                            filterName={f.FilterName}
                            filterDisplayName={f.DisplayName}
                            filterId={f.FilterId}
                            index={index}
                            tabsData={tabsData}
                            requestForId={requestForId}
                            getFilteredData={getFilteredData}
                            onCheckedOfColumnFilter={onCheckedOfColumnFilter}
                            onTextFilter={onTextFilter}
                            toggle={toggle}
                            columnFilters={columnFilters}
                            filteredDataColumns={filteredDataColumns}
                        />))
                    }
                </FilterList>
                <SaveViewPopUp
                    saveNewView={saveNewView}
                    toggle={toggle}
                    columnFilters={columnFilters}
                    tabsData={tabsData}
                    manageView={manageView}
                    saveNewTab={saveNewTab}
                    requestForId={requestForId}
                    removeTab={removeTab}
                    errors={errors}
                    clearErrors={clearErrors}
                    editTab={editTab}
                    clearFilters={clearFilters}
                />
            </FilterBar>
        );
    }
}

export default ServerFilterBar;



// WEBPACK FOOTER //
// ./app/components/filter-bar.jsx